const allowedStores = ['高崎スタジオ', '金沢スタジオ', '池袋スタジオ', '名古屋スタジオ', '神戸スタジオ', '盛岡スタジオ']

export { allowedStores }
